import React from 'react';
import { Loader } from '@front/ui-uchi';
import { Wrapper } from './elements';

const LoaderComponent = () => {
	return (
		<Wrapper>
			<Loader color="#DCECFF" size="1em" />
		</Wrapper>
	);
};

export default LoaderComponent;
